module.exports = __webpack_public_path__ + "static/media/TL.4bfb46dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TL.svg
// module id = 374
// module chunks = 0